import { useContext, useEffect, useState } from "react";
import StatusContext from "../store/status-context";

import main from "../../assets/css/main.module.css";
import MainIntroFirst from "../level1/MainIntroFirst";
import MainIntroAnimation from "../level1/MainIntroAnimation";
import lightBg from "../../assets/img/lighting.jpg";

export default function MainIntroduce() {
  const [styleThema, setStyleThema] = useState({});
  const context = useContext(StatusContext);

  useEffect(() => {
    if (context.light === "on") {
      setStyleThema(thema);
    } else {
      setStyleThema({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.light]);

  const thema = {
    opacity: 0.4,
  };

  return (
    <>
      <section id="home" className={main.home}>
        <MainIntroFirst />
        <img
          src={lightBg}
          alt="섹션1_배경"
          className={main.homeBg}
          style={styleThema}
        />
        <MainIntroAnimation />
      </section>
    </>
  );
}
